export default __webpack_public_path__ + "static/media/WindCreekWGray.7420d7d2.svg";